import { render, staticRenderFns } from "./dialog--create-extract.vue?vue&type=template&id=9d178fca&"
import script from "./dialog--create-extract.vue?vue&type=script&lang=js&"
export * from "./dialog--create-extract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports